<h2 mat-dialog-title>
  {{ 'CHANGE_VISIBILITY.TITLE' | translate }}
</h2>
<mat-dialog-content>
  <div class="dialog-content">
    @if (namespaceName$ | async; as namespaceName) {
      <glxy-form-field [bottomSpacing]="'none'" [disabled]="changingPrivacyLevel">
        <glxy-label>{{ 'VISIBILITY.MEETING_VISIBILITY_V2' | translate }}</glxy-label>
        <mat-select [(ngModel)]="selectedPrivacyLevel" [disabled]="changingPrivacyLevel">
          <mat-option [value]="PrivacyLevel.PRIVACY_LEVEL_OPEN">
            {{ 'VISIBILITY.OPEN' | translate: { namespaceName: namespaceName } }}
          </mat-option>
          <mat-option [value]="PrivacyLevel.PRIVACY_LEVEL_UNLISTED">
            {{ 'VISIBILITY.UNLISTED_V2' | translate: { namespaceName: namespaceName } }}
          </mat-option>
          <mat-option [value]="PrivacyLevel.PRIVACY_LEVEL_PRIVATE">
            {{ 'VISIBILITY.PRIVATE' | translate }}
          </mat-option>
        </mat-select>
        <glxy-hint>@if (selectedPrivacyLevel === PrivacyLevel.PRIVACY_LEVEL_OPEN) {
          {{ 'VISIBILITY.VISIBILITY_DESCRIPTION.OPEN' | translate: { namespaceName: namespaceName } }}
        } @else if (selectedPrivacyLevel === PrivacyLevel.PRIVACY_LEVEL_UNLISTED) {
          {{ 'VISIBILITY.VISIBILITY_DESCRIPTION.UNLISTED' | translate: { namespaceName: namespaceName } }}
        } @else if (selectedPrivacyLevel === PrivacyLevel.PRIVACY_LEVEL_PRIVATE) {
          {{ 'VISIBILITY.VISIBILITY_DESCRIPTION.PRIVATE' | translate: { namespaceName: namespaceName } }}
        }</glxy-hint>
      </glxy-form-field>
    } @else {
      <div class="stencil-shimmer"></div>
      <div class="stencil-shimmer"></div>
      <div class="stencil-shimmer"></div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close tabIndex="-1">
    {{ 'COMMON.CLOSE' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="savePrivacyLevel()" [disabled]="changingPrivacyLevel">
    {{ 'COMMON.SAVE' | translate }}
  </button>
</mat-dialog-actions>
